import { lazy, Suspense } from "react";
import LoadingPage from "../containers/loading";

const StoreSettingsPage = lazy(() =>
  import("../containers/storeSettings/settings.component")
);

export default function StoreSettingsRoute() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <StoreSettingsPage />
    </Suspense>
  );
}
